import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    icon: p => p.primaryDark,
    line: p => p.primaryLight,
    blockTitle: p => p.tertiaryDark,
    blockSubTitle: p => p.primaryDark,
    blockContent: p => p.tertiaryDark,
    background: p => `${p.tertiaryDark}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark,
    border: p => `rgba(${hexToRgb(p.accentWhite)}, 0.2)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    icon: p => p.primaryDark,
    line: p => p.primaryDark,
    blockTitle: p => p.tertiaryDark,
    blockSubTitle: p => p.primaryDark,
    blockContent: p => p.tertiaryDark,
    background: p => `${p.tertiaryLight}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.2)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    icon: p => p.primaryDark,
    line: p => p.primaryDark,
    blockTitle: p => p.tertiaryDark,
    blockSubTitle: p => p.primaryDark,
    blockContent: p => p.tertiaryDark,
    background: p => `${p.tertiaryExtraLight}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.2)`
  }
}
